<template>
  <div class="action-buttons" :key="`actions-${rowIndex}`">
    <div class="p-2">
      <action-button-skeleton v-if="buttonsLoading" />
      <expanded-row-buttons v-else-if="hasButtons" :row-id="rowId" />
    </div>
  </div>
</template>

<script>
import ActionButtonSkeleton from './ActionButtonSkeleton'
import ExpandedRowButtons from './grid-view/ExpandedRowButtons'
import { get } from 'lodash'

export default {
  name: 'ActionButtonContainer',
  components: {
    ActionButtonSkeleton,
    ExpandedRowButtons,
  },
  props: {
    rowIndex: {
      type: Number,
    },
  },
  computed: {
    buttonsLoading() {
      return get(this.rowDetails, [this.rowId, 'status'], 'pending') === 'pending'
    },
    hasButtons() {
      const rowKey = get(this.listData, [this.rowIndex, 'ROW_KEY'])
      return get(this.rowDetails, [rowKey, 'options', 'functions'], []).length
    },
    listData() {
      return this.$get('listData')
    },
    rowId() {
      return get(this.listData, [this.rowIndex, 'ROW_KEY'])
    },
    rowDetails() {
      return this.$get('rowDetails')
    },
    visibilityState() {
      return this.$get('visibilityState')
    },
  },
}
</script>
